import Cookies from 'universal-cookie';
import MainMenu from "../MainMenu/MainMenu";
import { useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";

export default function AppLayout (){

    const cookies = new Cookies();

    useEffect(() => {
        setInterval(() => {
          if(cookies.get("code")==undefined){
            window.location.replace(process.env.REACT_APP_DOMAIN+"/login");
          }
        }, 100000);
    }, []);

    return (
        <div>
        { cookies.get("code")==undefined ? 
            ( <div></div>)
            : 
            (  
                <MainMenu/>
            )
        }
        </div>
       )
       
}

